import React from 'react';
import { Loader } from '../../components/common/loader';

export default function Callback() {
    return <Loader />;
}
